import { render, staticRenderFns } from "./BaseModalFull.vue?vue&type=template&id=5c9dd04f&"
import script from "./BaseModalFull.vue?vue&type=script&lang=js&"
export * from "./BaseModalFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports